import { createSignal } from "solid-js";

import { registerSW } from "virtual:pwa-register";

const [pendingUpdate, setPendingUpdate] = createSignal<() => void>();

export { pendingUpdate };

const updateSW = registerSW({
  onNeedRefresh() {
    setPendingUpdate(() => void updateSW(true));
  },
  onOfflineReady() {
    console.info("Ready to work offline =)");
    // toast to users
  },
  onRegistered(r) {
    // Konkord: check for updates every minute; the page reloads on its own and
    // SessionRestore puts the user back into their call
    setInterval(() => r!.update(), 60_000);
  },
});
